import React, { useContext } from 'react';

// import { useNavigate } from 'react-router';
import styled from '@emotion/styled';

// import { DASHBOARD } from '../../../../routes/routeConstants';
import TranslatingContainer from '../../../TranslatingContainer/TranslatingContainer';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';
import PlainSuccessModal from '../../PlainSuccessModal';
import ConfirmCreateDispatcher from './ConfirmCreateDispatcher';
import PreviewDriverToRehire from './PreviewDriverToRehire';

interface RehireDriverLookupFlowModalProps {
  dispatcherData: any;
}
const RehireDriverLookupFlowModal: React.FC<
  RehireDriverLookupFlowModalProps
> = ({ dispatcherData }) => {
  const modalContext = useContext(ModalContext);
  // const navigate = useNavigate();
  // const successActionFn = () => {
  //   modalContext?.setShowModal(false);
  //   navigate(`/${DASHBOARD}`);
  // };

  // console.log('dispatcherData:', dispatcherData);

  return (
    <Container>
      <ModalContainer
        label='Rehire Driver'
        successComponent={() => (
          <PlainSuccessModal
            // successActionFn={successActionFn}
            description='The driver has been successfully rehired.'
            // btnLabel='Go to Dashboard'
          />
        )}
        showSuccessComponent={modalContext?.showSuccessComponent}
      >
        <FormContainer>
          <TranslatingContainer>
            <PreviewDriverToRehire data={dispatcherData} />
            <ConfirmCreateDispatcher dispatcherData={dispatcherData} />
          </TranslatingContainer>
        </FormContainer>
      </ModalContainer>
    </Container>
  );
};

export default RehireDriverLookupFlowModal;

const Container = styled.div`
  flex-direction: column;
  gap: 12px;
  display: flex;
`;

const FormContainer = styled.div`
  display: flex;
  overflow: hidden;

  @media (max-width: 884px) {
    width: 100%;
  }
`;
